import getApi from '../../api'
import { QuestionnaireTemplate } from '../../model/Questionnaire'

export const getSurveyQuestionnaire = (surveyId: number, questionnaireId: number) =>
  getApi().get<QuestionnaireTemplate>(`surveys/${surveyId}/questionnaires/${questionnaireId}`)
